<!--no sufficient fund-->
<div id="popup_makeCenter" *ngIf="AlertPlayerRegisterPopupEnable">
  <div id="popup_makeCenter_close" (click)="RegisterPopup(false)"></div>
  <div style="position: absolute; width: 100%; height: 100%">
    <table class="popup-container">
      <tr>
        <td>
          <div id="popup_makeCenter_close" (click)="RegisterPopup(false)"></div>
          <div class="popup-img-registerAlert">
            <img
              class="img-bg-registerAlert"
              src="assets/images/common/alert_register_now@2x.webp"
            />
            <img
              class="closeiconImg"
              src="./assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp"
              (click)="RegisterPopup($event)"
            />
            <div class="template-block-registerAlert">
              <div
                class="popup-header-registerAlert registerAlert-language-pos_1 lang-specific-font-name"
              >
                <span class="registerAlertPopup-language-txt">{{
                  'LANG01076' | translate
                }}</span
                ><!-- <br> -->
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
